import React from 'react'
import Modal from 'react-modal';
import './ConfirmModal.css'

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        height: '150px',
        borderColor: '#06a9bb',
        borderRadius: '10px',
        boxShadow: '0 0 12px #06a9bb35',

    },
};

const ConfirmModal = ({
    onConfirm,
    onCancel,
    show,
}) => {



    return (
        <Modal
            isOpen={show}
            onRequestClose={onCancel}
            style={customStyles}
            contentLabel="Delete Product"
        >
            <div className="custom-confirm pt-2">
                <h6>آیا از حذف محصول اطمینان دارید ؟</h6>
                <button onClick={onConfirm}>بله</button>
                <button onClick={onCancel}>خیر</button>
            </div>

        </Modal>
    )
}

export default ConfirmModal